import { isEmpty } from 'lodash'
import { useSelector } from 'react-redux'
import { getCurrentUserEmail } from 'store/AppState/selector'

const useEmailAuth = () => {
  const email = useSelector(getCurrentUserEmail)

  const regex = /\bshift4.com\b/
  const isEmailMatch = !isEmpty(email.match(regex))

  const isTest = localStorage.getItem('test')

  if (isTest) {
    // only for cypress tests
    return true
  } else {
    return isEmailMatch
  }
}

export default useEmailAuth
